import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function StopOrderDialog(props) {

    const classes = useStyles();
    const {t} = useTranslation();

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper style={{width:"520px"}} {...props} />
            </Draggable>
        );
    }

    const stopOrder = () => {
        props.action()
        props.closeDialog()
    }

    let totalPallets = 0;
    let progress = 0;

    if(props.productionOrder){
        if(props.productionOrder.bomOut.length > 0){
            totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)
        }
    
        if(props.producedBOMOut){
            progress =  Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier)
        }    
    } 

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >   <div className={classes.headerIcon}> <div className={classes.stopIcon}></div>
            </div>
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContentText className={classes.dialogContext}>
                {props.dialogContext}
            </DialogContentText>
            <div className={classes.dialogTable}>
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                    {t("Line")}
                    </div>
                    <div className={classes.valueCell}>
                        {props.productionOrder.machinePlannedCode}
                    </div>
                </div>
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                    {t("Pieces produced")}
                    </div>
                    <div className={classes.valueCell}>
                    {props.productionOrder.bomOut[0].quantityOnCarrier * progress + "/" + props.productionOrder.bomOut[0].quantityToProduce}
                    </div>
                </div>
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                    {t("Palets produced")}
                    </div>
                    <div className={classes.valueCell}>
                    {progress + "/" + totalPallets}                    
                    </div>
                </div> </div>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} onClick={() => props.closeDialog()}>
                    {t("CANCEL")}
              </Button>
                    <Button className={classes.stopButton} autoFocus onClick={() => stopOrder()} >
                        <div className={classes.whiteSquare}></div>{t("STOP")}
                 </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        textAlign: "center",
        marginLeft:"auto",
        marginRight:"auto",
        width:"235px",
    },
    stopButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#D84949",
        '&:hover': {
            backgroundColor: "#D84949",
        },
        margin: "3px",
        width: "110px",
        marginTop:"20px",
        marginBottom: "20px"
    },
    cancelButton:{
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#E6E8FE",
        '&:hover': {
            backgroundColor: "#E6E8FE",
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float:"left"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px",
        paddingBottom: "0px",
        cursor: 'move',
    },
    dialogContext: {
        color: "#D84949",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "10px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    },
    row: {
        width: "100%",
        height: "25px"
    },
    valueCell: {
        width: "40%",
        textAlign: "right",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'regular',
    },
    nameCell: {
        width: "60%",
        textAlign: "left",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    dialogTable: {
        height: "80px",
        width: "100%",
        paddingLeft: "60px",
        paddingRight: "60px",
        boxSizing: "border-box"
    },
    whiteSquare: {
        width: "15px",
        height: "15px",
        backgroundColor: "white",
        borderRadius: "4px",
        marginRight: "10px"
    },
    stopIcon: {
        backgroundColor: "#EFEFEF",
        width: "50px",
        height: "50px",
        borderRadius: "10px",
        marginLeft: "auto",
        marginRight: "auto"
    }

}));
